import EventVideoSection from "../Components/EventVideoSection";
import Programs from "../Components/Programs";
import MeetOurPastSponsors from "../Components/MeetOurPastSponsors";
import Hero from "../Components/Hero";
import MediaAbout from "../Components/MediaAboutUs";
import PreviousSession from "../Components/previousSession";
import PreviousEventSection from "../Components/PreviousEventSection";

export default function Home() {
  return (
    <>
      <Hero />
      <EventVideoSection />
      <MediaAbout showHeader={false} />
      <Programs />
      <PreviousSession />
      <MeetOurPastSponsors />
      <PreviousEventSection />
    </>
  );
}
